import { queryClient } from '@/lib/query-client';
import { resetIntegrations } from '@/libs/integrations';

/**
 * Clear user information on logout or unauthorized access
 * - Clears React Query cache
 * - Resets all integrations (Sentry, Mixpanel, Intercom)
 */
function clearUserInfo() {
  // Clear React Query cache
  queryClient.clear();

  // Reset integrations (clear user identification in Sentry, Mixpanel, Intercom)
  resetIntegrations();
}

export { clearUserInfo };
